export default {
  title: 'MRR report',
  fields: {
    name: 'Name',
    area: 'Area',
    mrr: 'MRR (net)',
  },
  buttons: {
    download_report: 'Download report',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data, please refresh the page',
  },
};
